import { isPublicRoute, isSecureLinkPage } from './api.utils'
import axios from 'axios'
import api from './api'
import { getAccessToken } from '../auth/tokenStorage'

export const requestInterceptor = async config => {
  const token = getAccessToken()

  config.metadata = { startTime: Date.now() }

  const isPublic = isPublicRoute(config.url)
  const isSecureLink = isSecureLinkPage()

  if (!isPublic) {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      if (!isSecureLink) {
        window.location.href = '/login'
      }
    }
  } else {
    if (config.headers && config.headers.Authorization) {
      delete config.headers.Authorization
    }
  }

  return config
}

export const successInterceptor = response => {
  return response
}

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

export const errorInterceptor = async error => {
  const originalRequest = error.config

  if (error.response?.status === 401 && !originalRequest._retry) {
    if (isPublicRoute(originalRequest.url)) {
      return Promise.reject(error)
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject })
      })
        .then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`
          return axios(originalRequest)
        })
        .catch(err => Promise.reject(err))
    }

    originalRequest._retry = true
    isRefreshing = true

    try {
      const newToken = await api.refreshToken()

      processQueue(null, newToken)
      originalRequest.headers.Authorization = `Bearer ${newToken}`
      return axios(originalRequest)
    } catch (refreshError) {
      console.error('Token refresh failed:', refreshError)
      processQueue(refreshError, null)
      // For secure link pages, reject the error so component can handle it
      // For other pages, the refreshToken function will handle redirect
      return Promise.reject(refreshError)
    } finally {
      isRefreshing = false
    }
  }

  if (error.response) {
    const status = error.response.status
    const requestId =
      error.response.headers?.['x-request-id'] ||
      error.response.headers?.['x-requestid']
    const method = (error.config?.method || 'get').toUpperCase()
    const url = error.config?.url
    const baseURL = error.config?.baseURL
    const start = error.config?.metadata?.startTime
    const durationMs = start ? Date.now() - start : undefined

    // Extract safe summary fields only
    const data = error.response.data
    const code = (data && (data.code || data.errorCode)) || undefined
    const rawMessage =
      (data && (data.message || data.error || data.title)) || undefined
    const message = rawMessage ? String(rawMessage).slice(0, 200) : undefined

    const context = {
      status,
      method,
      url,
      baseURL,
      requestId,
      durationMs,
      code,
      message
    }
    console.error(context)

  } else {
    console.error('Error', error.message)
  }
  return Promise.reject(error)
}
